var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3285 0.405924L4.78188 9.61926L2.24854 6.91259C1.78187 6.47259 1.04854 6.44592 0.515208 6.81926C-0.00479217 7.20592 -0.151459 7.88592 0.168541 8.43259L3.16854 13.3126C3.46187 13.7659 3.96854 14.0459 4.54187 14.0459C5.08854 14.0459 5.60854 13.7659 5.90188 13.3126C6.38188 12.6859 15.5419 1.76592 15.5419 1.76592C16.7419 0.539257 15.2885 -0.540742 14.3285 0.392591V0.405924Z",
    fill: "#2CD6F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon3);
export default __webpack_public_path__ + "static/media/check-icon3.ac509f72a02623372c4ade3b4f38aeff.svg";
export { ForwardRef as ReactComponent };